export default {"src":"/_next/static/media/loader.9bde7610.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};